<div class="login-background">
    <div class="login-wrapper">

        <div class="login-logo"></div>

        <div *ngIf="!success" class="login-title bold uk-margin-medium-top">Mot de passe oublié</div>
        <div *ngIf="success" class="login-title uk-margin-medium-top">le mot de passe a été changé avec succès</div>
        <div *ngIf="success" class="login-title uk-margin-medium-top">Vous pouvez vous reconnecter sur l'application avec ce nouveau mot de passe</div>

        <form *ngIf="!success" [formGroup]="passwordupdateForm" (ngSubmit)="changepassword(passwordupdateForm.value)">
            <div uk-grid class="uk-padding-remove">
                <div class="uk-width-1-1 uk-margin-large-top">
                    <div class="uk-margin">
                        <div class="uk-inline uk-width-9-10">
                            <label class="uk-form-label color-white uk-float-left" for="form-stacked-text">Nouveau mot de passe:</label>
                            <input class="uk-input input" type="password"
                                formControlName="newpassword" placeholder="MotDePasse34">
                        </div>
                    </div>

                    <div class="uk-margin">
                        <div class="uk-inline uk-width-9-10">
                            <label class="uk-form-label color-white uk-float-left" for="form-stacked-text">Confirmer le nouveau mot de passe:</label>
                            <input class="uk-input input" type="password"
                                formControlName="confirmpassword" placeholder="MotDePasse34">
                                <!-- [(ngModel)]="AZERTy1" -->
                        </div>
                    </div>

                    <div class="uk-margin">
                        <label class="uk-text-lighter uk-form-label color-white uk-float-left">Le mot de passe doit contenir au moins<br> 1 majuscule, 1 minuscule, 1 chiffre et 5 caractères minimums</label>
                    </div>
                </div>

                <div class="uk-width-1-1 uk-margin-large-top">
                    <button class="uk-button button login-button" type="submit">
                        <span class="bold">Mettre à jour</span>
                    </button>
                </div>
            </div>
        </form>
    </div>

    <div style="position: absolute; bottom: 5px; right: 5px; color: white;">
        v{{ release }}
    </div>
</div>